@if (versionCompatibility > 0) {
  <div id="version-warning">
    @if (versionCompatibility == 2) {
      <h6>Veralteter Server</h6>
    }
    @if (versionCompatibility == 1) {
      <h6>Veraltete App</h6>
    }
    <p>App-Version: {{version}} <br> Server-Version: {{generalSrv?.webConfig?.version}}</p>
  </div>
}
